<template>
  <div>
    <v-main class="pa-2">
      <div class="d-flex align-center mx-auto mt-6 mb-3" style="width: 98%">
        <v-icon color="#008cef" size="">mdi-information-outline</v-icon>
        <h2>{{ $t("前提情報") }}</h2>
      </div>
      <RichViewAndEditor
        :key="$route.path"
        :lidId="$route.params.id"
        :pageType="$route.name"
      ></RichViewAndEditor>
      <PDFViewAndSelector
        :key="$route.path"
        :lidId="$route.params.id"
        :pageType="$route.name"
      ></PDFViewAndSelector>

      <smallideapost
        v-if="isAuthed&&ideapost"
        :key="$route.path"
        :lidId="$route.params.id"
        :pageType="$route.name"
      ></smallideapost>
      <v-card height="300" elevation="0" style="z-index: -1"> </v-card>
      
    </v-main>
  </div>
</template>

<script>
import RichViewAndEditor from "../../components/RichViewAndEditor.vue";
import PDFViewAndSelector from "../../components/PDFViewAndSelector.vue";
import smallideapost from "../../components/contents/ideapost_pc.vue";
import Vue from "vue";
import firebase from "firebase";
export default {
  components: {
    RichViewAndEditor,
    PDFViewAndSelector,
    smallideapost,
  },
  data: (vm) => ({
    ideapost: false,
    contentedit: false,
    db: null, // created で初期化
    content: "", // アイデアを入力した時に v-model でデータを保存
  }),
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || "";
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    lid() {
      return this.$store.state.lid;
    },
    alid() {
      return this.$store.state.alid;
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
  },
  created() {
    this.db = firebase.firestore();
  },
  mounted() {
    // ideapostのvalueを、0/lidId ドキュメントのsettings.postIdeaOnContentを参照して取得
    this.db.collection("0").doc(this.$route.params.id).get()
      .then((doc) => {
        if (doc.exists) {
          this.ideapost = doc.data().settings?.postIdeaOnContent || false;
        }
      });
  },
  methods: {
    onedoFold(el) {
      this.$emit("doFold", el);
    },
  },
};
</script>

<style scoped>
.pl312 {
  padding-left: 312px !important;
}
.pl80 {
  padding-left: 80px !important;
}
</style>
